module.exports = __webpack_public_path__ + "img/resolve4.3a6653a2.png";